// 👥 Employés E3b — helpers rôles multiples (miroir de services/permissions_helper.py).
export const ROLES_ATTRIBUABLES = ['charge_projet', 'adjoint_admin', 'representante', 'chef_equipe', 'peintre', 'installateur'];
export const ROLE_LABELS = {
  proprietaire: 'Propriétaire', charge_projet: 'Chargée de projet', adjoint_admin: 'Adjoint administratif',
  representante: 'Représentante', chef_equipe: "Chef d'équipe", peintre: 'Peintre', installateur: 'Installateur LMDS',
};
const ALIAS = { sous_traitant: 'installateur', admin: 'adjoint_admin', 'chef d\'équipe': 'chef_equipe' };

export const normaliserRole = (r) => {
  if (!r || typeof r !== 'string') return null;
  const n = r.trim().toLowerCase();
  return ALIAS[n] || n;
};

export const estProprietaire = (user) => !!user && (normaliserRole(user.role) === 'proprietaire' || user.est_proprietaire === true);

export const rolesDe = (user) => {
  if (!user) return [];
  const bruts = (Array.isArray(user.roles) && user.roles.length > 0) ? user.roles : [user.role, user.role_terrain, user.role_admin];
  const out = [];
  bruts.forEach((r) => { const n = normaliserRole(r); if (n && !out.includes(n)) out.push(n); });
  return out;
};

export const aLeRole = (user, ...roles) => {
  const voulus = roles.map(normaliserRole);
  return rolesDe(user).some((r) => voulus.includes(r));
};

export const libelleRole = (r) => ROLE_LABELS[normaliserRole(r)] || r || '—';
